@if(visible()){
<!-- <div class="jk-btnedit-border">
 -->
<div [ngStyle]="flexStyle" class="jk-margin0 ">
  <div>
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  </div>
  <div class="w-full jk-margin0 flex gap-1">
    <!-- (blur)="onBlur($event)"
      [matAutocomplete]="matAutocomplete"
      class="jk-text-border"
    -->
    <input btnedit #btnedit id="btnedit" matInput type="text" [placeholder]="placeholder" [disabled]="disabled()"
      [readonly]="readonly()" [(ngModel)]="value" [ngModelOptions]="{updateOn: 'blur'}" [ngStyle]="widthStyle"
      (blur)="onValueBlur()" [matTooltip]="value"

      class="flex-1 min-w-12 outline-none border-b border-gray-300 focus:border-blue-500 transition-colors bg-transparent">

    @if (showClearButton() && (!readonly())) {
    <button class="text-gray-500 hover:text-red-500 transition-colors" #close_button matSuffix mat-icon-button
      aria-label="Clear" (click)="doClearClick($event)">
      <mat-icon class="text-[12px] leading-none flex justify-center items-center">close_small</mat-icon>
    </button>
    }

    @if(showOpenWinButton() && (!readonly())){
      <!-- class="text-blue-600 hover:text-blue-800 transition-colors" #more_button matSuffix mat-icon-button -->
    <button class="btn-accent jk-edit-button"
      aria-label="open win" (click)="doOpenWinClick($event)">
      <mat-icon class="jk-edit-button__icon">more_vert</mat-icon>
    </button>
    }
  </div>
  @if (showName()) {
  <span
    class="ml-2  text-gray-700 bg-gray-300 px-2 py-0.5 rounded border border-gray-200 ">{{displayName}}</span>
  }
</div>
<!-- </div> -->
}
